import { useState } from "react";
import { ImageOff } from "lucide-react";

const VARIANT = /-(300|600|900)\.webp$/;
const at = (src, w) => src.replace(VARIANT, `-${w}.webp`);

export const ProductImage = ({ src, alt = "", w = 600, sizes, className = "", width, height, eager, testid }) => {
  const [failed, setFailed] = useState(null);
  if (!src || failed === src) {
    return (
      <span role="img" aria-label={alt || "Foto in arrivo"} className={`flex items-center justify-center bg-[#F3E9D7] text-stone-400 ${className}`} data-testid={testid ? `${testid}-placeholder` : undefined}>
        <ImageOff className="h-1/4 max-h-10 w-1/4 max-w-10" strokeWidth={1.5} />
      </span>
    );
  }
  const own = VARIANT.test(src);
  return (
    <img src={own ? at(src, w) : src} srcSet={own ? `${at(src, 300)} 300w, ${at(src, 600)} 600w, ${at(src, 900)} 900w` : undefined}
      sizes={own ? sizes || `${w}px` : undefined} alt={alt} width={width} height={height} loading={eager ? "eager" : "lazy"} decoding="async"
      onError={() => setFailed(src)} className={className} data-testid={testid} />
  );
};
